import React from 'react';
import { cs, type Argument } from '@bbkAdminUtils/css-utils';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';
import icons from '@bbkFunnelUtils/icons';

import '@bbkAdminStylesheets/icon.scss';

type Props = {
  name: keyof typeof icons;
  classNames?: Argument;
};
const Icon: ReactFCC<Props> = ({ name, classNames }) => (
  <div className={cs('bbk-icon', classNames)}>{icons[name]}</div>
);

export default Icon;
